import { AuthStorage } from "utils/auth-storage";
import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Table } from "antd";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import LoadingComponent from "components/loading-component";
import Text from "components/text";
import { WarehouseServices } from "apis/Services/WarehouseService";
import { WAREHOUSE_CANNED_REPORTS } from "./report-configs";
import styles from "./warehouse-reports.module.css";

export default function WarehouseReports() {
  const { company_id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [accessLevel, setAccessLevel] = useState(0);

  useEffect(() => {
    let isMounted = true;
    const code = AuthStorage.getItem("token");
    const email = AuthStorage.getItem("email");

    WarehouseServices.inventoryPageAccessLevel({
      company: company_id,
      code,
      loginEmail: email,
    })
      .then((res) => {
        if (!isMounted) {
          return;
        }

        setAccessLevel(parseInt(res?.accessLevel) || 0);
      })
      .catch((err) => {
        console.log(err);

        if (isMounted) {
          setAccessLevel(0);
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [company_id]);

  const dataSource = useMemo(() => {
    return WAREHOUSE_CANNED_REPORTS.map((report) => ({
      key: report.key,
      Report:
        accessLevel > 0 ? (
          <Link className={styles.linkStyle} to={report.slug}>
            {report.title}
          </Link>
        ) : (
          <span className={styles.linkStyleNoPermission}>{report.title}</span>
        ),
      Description: report.description,
    }));
  }, [accessLevel]);

  const columns = [
    {
      title: "Report",
      dataIndex: "Report",
      key: "Report",
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
    },
  ];

  return (
    <div className="bg-white p-4 rounded-3 d-flex flex-column justify-content-center">
      {isLoading && (
        <div className="row d-flex justify-content-center">
          <LoadingComponent />
        </div>
      )}

      {!isLoading && accessLevel === 0 && (
        <div className="row w-100 d-flex justify-content-center p-5">
          <div className="d-flex flex-column align-items-center text-center gap-3">
            <LockRoundedIcon style={{ fontSize: "5rem", color: "#999" }} />
            <h6 className="mt-2 mb-0 text-muted">
              You do not have the necessary permissions to access this page.
            </h6>
          </div>
        </div>
      )}

      {!isLoading && accessLevel > 0 && (
        <div style={{ width: "85%" }} className="align-self-center">
          <div className="row">
            <div>
              <h3 className="fw-bold p-0 m-0">Warehouse Reports</h3>
              <p className="opacity-75 mt-2 p-0">
                Review canned warehouse reports for inventory history, inactivity,
                and draft stock planning.
              </p>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-12">
              <Text className={styles.header}>Canned Reports</Text>
            </div>
          </div>

          <div className="row mt-4">
            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              bordered
            />
          </div>
        </div>
      )}
    </div>
  );
}
